<template>
    <div class="loading">
        <v-progress-circular
            :size="30"
            color="rgba(255, 255, 255)"
            indeterminate
        ></v-progress-circular>
        {{ text }}
    </div>
</template>

<script>
export default {
    name: 'sp-loader',
    props: {
        text: {
            type: String,
            required: false,
            default: 'Loading...'
        }
    }
}
</script>

<style lang="scss" scoped>
.loading {
    position: absolute;
    background: rgba(0,0,0,0.4);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $white;

    .v-progress-circular {
        margin-right: 10px;
    }
}
</style>
